import { atom } from "recoil";

const localStorageEffect =
  (key) =>
    ({ setSelf, onSet }) => {
      const savedValue = localStorage.getItem(key);
      if (savedValue != null && key !== "token" && key !== 'user') {
        // handle token being saved as a string and not a json object
        setSelf(JSON.parse(savedValue));
      } else if (savedValue !== null) {
        setSelf(savedValue);
      }

      onSet((newValue, _, isReset) => {
        isReset
          ? localStorage.removeItem(key)
          : localStorage.setItem(key, JSON.stringify(newValue));
      });
    };

// app-related globals
const Level = atom({
  key: "level",
  default: "es",
});

const Plan = atom({
  key: "plan",
  default: null,
});

const Plans = atom({
  key: "plans",
  default: [],
});

// auth-related globals
const Token = atom({
  key: "token",
  default: null,
  effects: [localStorageEffect("token")],
});

const User = atom({
  key: "user",
  default: null,
  effects: [localStorageEffect("username")],
});

// Map sidebar globals

const RedistrictingData = atom({
  key: "redistrictingdata",
  default: [],
});

const RedistrictingDataID = atom({
  key: "redistrictingdataid",
  default: null,
});

const MapDrawerOpen = atom({
  key: "mapdraweropen",
  default: false,
});

const MapDrawerWidth = atom({
  key: "mapdrawerwidth",
  default: 400,
});

// Map menu globals TBD
// anchor point

export {
  Level,
  Plan,
  Plans,
  User,
  Token,
  RedistrictingData,
  RedistrictingDataID,
  MapDrawerOpen,
  MapDrawerWidth,
};
